import router from './router'
// import store from './store'
// import { Message } from 'element-ui'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { getToken, setToken, removeToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // console.info('router.beforeEach', to, from, next)
  // start progress bar
  // NProgress.start()

  // // set page title
  // document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    // if (to.path === '/user/login') {
    //   // if is logged in, redirect to the home page
    //   next({ path: '/' })
    //   // window.location.reload() // 打包后的BUG：登出后页面无反应
    //   // NProgress.done()
    // } else {
    //   next()
    // }
    next()
  } else {
    /* has no token*/
    console.info('has no token')
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/user/login?redirect=${to.fullPath}`)
      // NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  // NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js